import React from 'react';
import styled from 'styled-components';

import { MenuType } from 'src/dispensary/core-menu/components/header/menu-type';
import { StoreStatus } from 'src/dispensary/core-menu/components/header/store-status';

export const InfoBar = (): JSX.Element => (
  <InfoContainer>
    <StoreStatus />
    <MenuType />
  </InfoContainer>
);

const InfoContainer = styled.div`
  align-items: center;
  background-color: var(--dcm-infobar-bg);
  border-bottom: var(--dcm-infobar-border-width) solid var(--dcm-infobar-border-color);
  color: var(--dcm-infobar-text-color);
  display: flex;
  gap: var(--dcm-infobar-gap);
  justify-content: space-between;
  padding: var(--dcm-infobar-padding-y) var(--dcm-infobar-padding-x);
  width: 100%;
`;
